<template>
    <side-bar-drawer
        :isOpen="candidateSummarySideMenuOpen"
        @close="toggleProfile"
        :completionPercentage="35"
        :data="drawerData"
    >
        <slot></slot>
    </side-bar-drawer>
</template>

<script>
import SideBarDrawer from './SideBarDrawer.vue';
export default {
    components: {
        SideBarDrawer
    },
    props: {
        personalDetailPercentage: {
            type: Number,
            default: 0
        },
        drawerData: {
            type: Object,
            default: {
                profilePercentComplete: 0,
                personalDetails: {
                    completed: false,
                    edit: true
                },
                introduceYourSelf: {
                    completed: false,
                    edit: true
                },
                yourBio: {
                    completed: false,
                    edit: true
                },
                cvDetails: {
                    languages: {
                        completed: false,
                        edit: true
                    },
                    education: {
                        completed: false,
                        edit: true
                    },
                    workExperience: {
                        completed: false,
                        edit: true
                    },
                    reference: {
                        completed: false,
                        edit: true
                    }
                },
                aimModules: {
                    cognitive: {
                        completed: false,
                        edit: true,
                        disabled: false
                    },
                    questionnaire: {
                        completed: false,
                        edit: true,
                        disabled: false
                    }
                },
                editConsent: false
            }
        }
    },
    data() {
        return {
            data: {},
        };
    },
    computed: {
        candidateSummarySideMenuOpen() {
            return this.$store.getters.candidateSummarySideMenuOpen;
        },
    },
    methods: {
        toggleProfile() {
            this.$store.dispatch('candidateSummarySideMenuOpen', false);
        },
    },
    mounted() {

    },

};
</script>